import { Form, Descriptions, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { ActionsPage } from 'Model'
import ConfigItem from './ConfigItem'
import './ConfigItems.scss'
import { configDataTypes } from './constants'

ConfigItems = ({ accessor, form, template, darkModeEnabled }) ->

  [items, setItems] = accessor

  setItem = (item) ->
    i = items.findIndex(({ name }) -> name is item.name)
    setItems([_.set(items, i, item)...])

  <Descriptions
    title="Config"
    bordered
    style={{ marginTop: 25 }}
    column={1}
  >
    {items
      .filter(({ name }) -> name not in ['project', 'user', 'zipped'])
      .map((item) ->
        <Descriptions.Item
          label={
            <>
              { _.capitalize(item.name)}
              <Tooltip title={item.description}>
                <QuestionCircleOutlined style={{ float: 'right', color: '#58bd91', marginTop: 5 }} />
              </Tooltip>
            </>
          }
          key={item.name}
          className="services-config-items"
        >
          <Form.Item
            valuePropName={if item.type is configDataTypes.boolean then 'checked' else 'value'}
            name={item.name}
            rules={[{ required: item.required, message: 'This field is required!' }]}>
            <ConfigItem
              data={item}
              onChange={(value) ->
                setItem({ item..., value })
              }
              template={template}
              darkModeEnabled={darkModeEnabled}
            />
          </Form.Item>
        </Descriptions.Item>
      )
    }
  </Descriptions>

export default ConfigItems
